/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState, useEffect } from "react";
import { store } from "../Store";
import { useLocation } from "react-router-dom";
import { PublicHeader } from "./public-header/index.js";
import { IndividualHeader } from "./individual-header/index.js";
import { GeneralHeader } from "./general-header/index.js";

import { AccesibilidadContext } from "../../contexts/AccesibilidadContext.js";
import useIsMobile from "../../js/utilities/useIsMobile.js";
import { useLanguage } from "../../hooks/use-language.js";
import { useTranslations } from "../../hooks/use-translations.js";
import { Accessibility } from "../accesibility/index.js";

/**
 * Este componente renderiza el header del proyecto. Su principal función es identificar si la sesión esta activa. A partir de esto, asocia el tipo de usuario para mostrar el Header correspondiente. 
 * @returns {JSX.Element} Header
 */
const Header = () => {
	const globalState = useContext(store);
	const { state } = globalState;
	const accebilidadState = useContext(AccesibilidadContext);

	const isLogged = state.sesionActiva !== null && state.sesionActiva === "SI";
	const location = useLocation();
	const isPersonalAccount = state?.isPersonalAccount;
	const isIndividualUser = state?.cantidadLibros <= 40 && globalState?.state?.cantidadLibros >= 0;
	const lang = useLanguage();
	const textosInterfaz = useTranslations({ section: "header", lang: lang, array: true });

	const [esTemaClasico, setEsTemaClasico] = useState(true);
	const isMobile = useIsMobile();

	/*Actualiza el estado de EsTemaClasico. */
	useEffect(() => {
		let tema = accebilidadState?.temaActual !== 'clasico' ? false : true;
		setEsTemaClasico(tema);
	}, [accebilidadState])


	const skipLink = (event) => {
		event.preventDefault();
		const container = document.querySelector("#main");
		if (container) {
			container.tabIndex = -1;
			container.focus();
			setTimeout(() => container.removeAttribute("tabindex"), 1000);
		}
	};

	const skipLinkToFooter = (event) => {
		event.preventDefault();
		const container = document.querySelector("#footer");
		if (container) {
			container.tabIndex = -1;
			container.focus();
			setTimeout(() => container.removeAttribute("tabindex"), 1000);
		}
	};

	return (
		<>
			<header
				style={{
					height: !location.pathname.includes('/visor') ? 82 : 0,
				}}
				role="banner"
			>
				{state.mainDataLoaded === true && !location.pathname.includes('/visor') && (
					<>
						<button onClick={(e) => skipLink(e)} className="skip-link focusable-red">
							{textosInterfaz?.skip || "Saltar al contenido"}
						</button>
						<button onClick={(e) => skipLinkToFooter(e)} className="skip-link focusable-red">
							{textosInterfaz?.skip_to_footer || "Saltar al pie de página"}
						</button>
					</>
				)}
				{
					isLogged && isPersonalAccount && !location.pathname.includes('/visor') &&
					<GeneralHeader/>
				}
				{!isPersonalAccount && isLogged && !location.pathname.includes('/visor') && state.cantidadLibros <= 40 && globalState?.state?.cantidadLibros >= 0 &&
					<IndividualHeader />
				}


				{!isPersonalAccount && isLogged && !location.pathname.includes('/visor') && state.cantidadLibros !== "NULL" && state.cantidadLibros > 40 &&
					<GeneralHeader />
				}

				{!isLogged && !location.pathname.includes('/visor') &&
					<PublicHeader />
				}
				<Accessibility />
			</header>
		</>
	);
};

export default Header;
